import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuex from "vuex";
import axios from "axios";
import MintUI from "mint-ui";
import "mint-ui/lib/style.css";
//調試
/*import Vconsole from "vconsole";
const vConsole = new Vconsole();
Vue.use(vConsole);*/
import VueAwesomeSwiper from "vue-awesome-swiper";
// require styles
import "swiper/dist/css/swiper.css";
//弹框插件
/*import {Alert, Confirm, Toast} from 'wc-messagebox'
import 'wc-messagebox/style.css'

Vue.use(Alert);
Vue.use(Confirm);
Vue.use(Toast);*/
//图片放大插件
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";

//vue-i18n 引用
import VueI18n from "vue-i18n";
import zh from "./assets/js/lang/zh";
import en from "./assets/js/lang/en";
import kor from "./assets/js/lang/kor";
import jap from "./assets/js/lang/jap";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "zh",
  fallbackLocale: "zh",
  formatFallbackMessages: true, //打开回退槽函数，当遇到无法识别的字符，将回退到 fallBackLocale 指定的语言类型
  messages: {
    zh: zh,
    en: en,
    jap: jap,
    kor: kor
  }
});
//1中文；2英文；3日文；4韩文
// window.$lang="1";
switch (i18n.locale) {
  case "zh":
    window.$lang = "1";
    break;
  case "en":
    window.$lang = "2";
    break;
  case "jap":
    window.$lang = "3";
    break;
  case "kor":
    window.$lang = "4";
    break;
}
Vue.use(preview);
axios.defaults.withCredentials = true;
Vue.prototype.$http = axios;
Vue.prototype.htmlDecode = function(text) {
  var temp = document.createElement("div");
  temp.innerHTML = text;
  var output = temp.innerText || temp.textContent;
  temp = null;
  return output;
}; //轉碼
import msgBoxComponent from "./components/endPage/msgBox.vue";

let msgBox = (options = {}) => {
  let msgBoxConstructor = Vue.extend(msgBoxComponent);
  let instance = new msgBoxConstructor({
    el: document.createElement("div")
  });
  document.body.appendChild(instance.$el);
  // 将单个 confirm instance 的配置合并到默认值中
  Object.assign(instance.$data, options);
  return new Promise((resolve, reject) => {
    instance.show = true;
    let successBtn = instance.successBtn;
    let cancelBtn = instance.cancelBtn;
    instance.successBtn = () => {
      resolve();
      successBtn();
    };
    instance.cancelBtn = () => {
      reject();
      cancelBtn();
    };
  });
};
Vue.prototype.$msgbox = msgBox; //編碼
// //添加全局API

//页面历史记录 的全局函数
/*Vue.prototype.$setgoindex = function () {
    if (window.history.length <= 1) {
        if (location.href.indexOf('?') === -1) {
            window.location.href = location.href + '?goindex=true'
        } else if (location.href.indexOf('?') !== -1 && location.href.indexOf('goindex') === -1) {
            window.location.href = location.href + '&goindex=true'
        }
    }
};*/
/*Vue.prototype.htmlEncode = function (html){
    var temp = document.createElement ("div");
   (temp.textContent != undefined ) ? (temp.textContent = html) : (temp.innerText = html);
    var output = temp.innerHTML;
    temp = null;
    return output;
};*/
import { state } from "./store/state";
import { actions } from "./store/actions";
import { mutations } from "./store/mutations";
import market from "./store/modules/market";
import show from "./store/modules/show";
import food from "./store/modules/food";
import park from "./store/modules/park";
import service from "./store/modules/service";
import activity from "./store/modules/activity";
import endPage from "./store/modules/endPage";
import home from "./store/modules/home";
import personal from "./store/modules/personal";
Vue.use(Vuex);
Vue.use(MintUI);
Vue.use(VueAwesomeSwiper);
const store = new Vuex.Store({
  state,
  actions,
  mutations,
  modules: {
    market: market,
    show: show,
    food: food,
    park: park,
    service: service,
    activity: activity,
    endPage: endPage,
    home: home,
    personal: personal
  }
});

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
